import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import keycode from 'keycode';
import InputAdornment from '@material-ui/core/InputAdornment';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import DeleteIcon from '@material-ui/icons/Delete';
import FilterListIcon from '@material-ui/icons/FilterList';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import axios from 'axios'
import Slide from '@material-ui/core/Slide';
import Grid from '@material-ui/core/Grid';
import AppBar from '@material-ui/core/AppBar';
import AddIcon from '@material-ui/icons/Add';
import Paper from '@material-ui/core/Paper';
import { DatePicker } from 'material-ui-pickers';

import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import moment from 'moment';
import MenuItem from '@material-ui/core/MenuItem';
import Divider from '@material-ui/core/Divider';
import green from '@material-ui/core/colors/green';
import amber from '@material-ui/core/colors/amber';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import WarningIcon from '@material-ui/icons/Warning';
import CloseIcon from '@material-ui/icons/Close';
import CircularProgress from '@material-ui/core/CircularProgress';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';

import { BASE_URL_JAVAZ_API } from 'constants/ActionTypes';

const apiUrlHeader = BASE_URL_JAVAZ_API;
const apiUrl = apiUrlHeader + "/vehicle-type";
const masterTitleLower = "vehicle-type";
const masterTitleCapital = "Vehicle Type";

// get token and set config for call the API
const token = localStorage.getItem('apiKey')
const companyIdGlobal = localStorage.getItem('companyId')
const config = {
  headers: {
    'Content-Type': 'application/json',
    "Authorization": `Bearer ${token}`
  }
}
//length data for general
const LENGTH_DATA = 20

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

import InputVirtual from 'components/InputVirtual'

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

const styles = theme => ({
  appBar: {
    position: 'relative',
  },
  flex: {
    flex: 1,
  },
  button: {
    margin: theme.spacing.unit,
  },
  leftIcon: {
    marginRight: theme.spacing.unit,
  },
  rightIcon: {
    marginLeft: theme.spacing.unit,
  },
  paper: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
  },
});

const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon,
};
function MySnackbarContent(props) {
  const { classes, className, message, onClose, variant, ...other } = props;
  const Icon = variantIcon[variant];

  return (
    <SnackbarContent
      className={classNames(classes[variant], className)}
      aria-describedby="client-snackbar"
      message={
        <span id="client-snackbar" className={classes.message}>
          <Icon className={classNames(classes.iconSnack, classes.iconVariant)} />
          {message}
        </span>
      }
      action={[
        <IconButton
          key="close"
          aria-label="Close"
          color="inherit"
          className={classes.close}
          onClick={onClose}
        >
          <CloseIcon className={classes.icon} />
        </IconButton>,
      ]}
      {...other}
    />
  );
}

const MySnackbarContentWrapper = withStyles(theme => ({
  success: {
    backgroundColor: green[600],
  },
  error: {
    backgroundColor: theme.palette.error.dark,
  },
  info: {
    backgroundColor: theme.palette.primary.dark,
  },
  warning: {
    backgroundColor: amber[700],
  },
  iconSnack: {
    fontSize: 20,
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing.unit,
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
}))(MySnackbarContent);

class DialogForm extends React.Component {

  //handle company dd add
  callbackCompany = ({ id }) => {
    this.setState({ companyIdForm: id })
  };
  // end function ==============================================================================

  async componentDidMount() {
    this.props.showDialog(this.showDialog);

  };

  async componentDidUpdate() {

    if (this.state.isParentClick == true) {
      if (this.props.idData == 0) {
        this.setState({
          openDialog: true,
          action: "tambah",

          companyIdForm: companyIdGlobal,
          nameForm: "",
          lengthDimensionForm: 0,
          heightDimensionForm: 0,
          widthDimensionForm: 0,
          loadCapacityForm: 0,
          maxSpeedForm: 0,
          minSpeedForm: 0,
          averageSpeedForm: 0,
          descriptionForm: ""
        })
      } else {
        this.setState({ action: "ubah" });
        this.handleClickOpenEdit(this.props.idData);
      }
      this.setState({ isParentClick: false });
    }

  };

  constructor(props, context) {
    super(props, context);
    this.state = {
      openDialog: false,
      isParentClick: false,
      action: "tambah",

      //snackbar state
      openSnackSuccess: false,
      openSnackErr: false,
      messageSnackBar: "",

      idData: 0,

      //FORM================================================
      companyIdForm: companyIdGlobal,
      nameForm: "",
      lengthDimensionForm: 0,
      heightDimensionForm: 0,
      widthDimensionForm: 0,
      loadCapacityForm: 0,
      maxSpeedForm: 0,
      minSpeedForm: 0,
      averageSpeedForm: 0,
      descriptionForm: "",
      loading: false
    };

    this.showDialog = this.showDialog.bind(this);
  };

  showDialog() {

    this.setState({ isParentClick: true });
  };

  // logic new ================================================================================
  handleClose = async (param) => {
    if (param === 'batal') {

      this.setState({ idData: 0, openDialog: false });
      this.props.closeDialog();
    } else if (param === 'tambah') {
      this.setState({ idData: 0, loading: true })

      const data = {
        "name": this.state.nameForm,
        "company": parseInt(this.state.companyIdForm),
        "length_dimension": parseInt(this.state.lengthDimensionForm),
        "height_dimension": parseInt(this.state.heightDimensionForm),
        "width_dimension": parseInt(this.state.widthDimensionForm),
        "load_capacity": parseInt(this.state.loadCapacityForm),
        "max_speed": parseInt(this.state.maxSpeedForm),
        "min_speed": parseInt(this.state.minSpeedForm),
        "average_speed": parseInt(this.state.averageSpeedForm),
        "description": this.state.descriptionForm
      }

      let obj = JSON.stringify(data);

      const result = await axios.post(apiUrl + '/new', obj, config)
        .then(res => res)
        .catch((error) => error.response)
      if (result.data.code === 201) {
        NotificationManager.success("Success insert " + masterTitleLower + " data", 'Success message')
        this.setState({ openDialog: false, loading: false });
        this.props.closeDialog(result.data);
      } else {
        this.setState({loading: false})
        NotificationManager.error("Failed insert " + masterTitleLower + " data : " + result.data.message, 'Error message')
      }
    } else if (param === 'ubah') {
      const { idData } = this.state
      this.setState({loading: true})
      const data = {
        "name": this.state.nameForm,
        "company": parseInt(this.state.companyIdForm),
        "length_dimension": parseInt(this.state.lengthDimensionForm),
        "height_dimension": parseInt(this.state.heightDimensionForm),
        "width_dimension": parseInt(this.state.widthDimensionForm),
        "load_capacity": parseInt(this.state.loadCapacityForm),
        "max_speed": parseInt(this.state.maxSpeedForm),
        "min_speed": parseInt(this.state.minSpeedForm),
        "average_speed": parseInt(this.state.averageSpeedForm),
        "description": this.state.descriptionForm
      }
      let obj = JSON.stringify(data);
      const result = await axios.put(`${apiUrl}/edit/${idData}`, obj, config)
        .then(res => res)
        .catch((error) => error.response)
      if (result.data.code === 200) {

        NotificationManager.success("Success update " + masterTitleLower + " data", 'Success message')

        this.setState({ openDialog: false, loading: false });
        this.props.closeDialog(result.data);
      } else {
        this.setState({loading: false})
        NotificationManager.error("Failed update " + masterTitleLower + " data : " + result.data.message, 'Error message')

      }
    }

  };


  //logic open edit ===========================================================================
  handleClickOpenEdit = async (id) => {
    this.setState({ openDialog: true, idData: id })

    const result = await axios.get(`${apiUrl}/${id}`, config)
      .then(res => res)
      .catch((error) => error.response)

    if (result.data.code === 200) {

      this.setState({
        companyIdForm: result.data.data.company,
        nameForm: result.data.data.name,
        lengthDimensionForm: result.data.data.length_dimension,
        heightDimensionForm: result.data.data.height_dimension,
        widthDimensionForm: result.data.data.width_dimension,
        loadCapacityForm: result.data.data.load_capacity,
        maxSpeedForm: result.data.data.max_speed,
        minSpeedForm: result.data.data.min_speed,
        averageSpeedForm: result.data.data.average_speed,
        descriptionForm: result.data.data.description
      })
    }

  };

  // end function vehicle-type =================================================================

  render() {
    const { classes } = this.props
    const {loading} = this.state
    return (
      <div>
        <Snackbar
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          open={this.state.openSnackSuccess}
          autoHideDuration={4000}
          onClose={() => this.setState({ openSnackSuccess: false })}
        >
          <MySnackbarContentWrapper
            onClose={() => this.setState({ openSnackSuccess: false })}
            variant="success"
            message={this.state.messageSnackBar}
          />
        </Snackbar>
        <Snackbar
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          open={this.state.openSnackErr}
          autoHideDuration={4000}
          onClose={() => this.setState({ openSnackErr: false })}
        >
          <MySnackbarContentWrapper
            onClose={() => this.setState({ openSnackErr: false })}
            variant="error"
            message={this.state.messageSnackBar}
          />
        </Snackbar>

        <NotificationContainer />

        <Dialog
          fullScreen
          open={this.state.openDialog}
          onClose={() => this.handleClose('batal')}
          TransitionComponent={Transition}
        >
          <AppBar className="sticky-container">
            <Toolbar>
              <Typography variant="h6" color="inherit" className={classes.flex}>
                {masterTitleCapital}
              </Typography>
              <Button 
						variant="raised" 
						disabled={loading}
						style={{ cursor: loading ? 'not-allowed' : 'pointer'}} 
						className="bg-white text-black" 
						onClick={() => { if(!loading) this.handleClose('batal')}}
					>
                        batal
                    </Button>&nbsp;&nbsp;
                    <Button 
						variant="raised" 
						color="primary" 
						disabled={loading} 
						style={{ cursor: loading ? 'not-allowed' : 'pointer'}} 
						onClick={() => { if(!loading) this.handleClose(this.state.action) }}
					>		 
						{loading ? (
							<CircularProgress
								className="text-white"
								size={24}
							/>						  
						) : this.state.action}
                    </Button>
            </Toolbar>
          </AppBar>
          <br />
          <br />
          <div className="app-wrapper">
            <br />
            <br />
            <Grid container spacing={24}>
              <Grid item xs={6}>
                <Grid item xs={12}>
                  <InputVirtual
                    label="Perusahaan"
                    value=""
                    name="name"
                    lengthData={20}
                    url={apiUrlHeader + "/company/search"}
                    getData={this.callbackCompany}
                    setData={[{ name: "id", value: this.state.companyIdForm.toString(), "logic_operator": "=", "operator": "AND" }]}
                    fullWidth={true}
                    dialogForm="DialogFormCompany"
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    label="Nama"
                    // className={classes.textField}
                    value={this.state.nameForm}
                    fullWidth
                    onChange={(e) => this.setState({ nameForm: e.target.value })}
                    margin="normal"
                  />

                </Grid>
                <Grid item xs={12}>
                  <TextField
                    label="Dimensi Panjang"
                    type="number"
                    // className={classes.textField}
                    value={this.state.lengthDimensionForm}
                    fullWidth
                    onChange={(e) => this.setState({ lengthDimensionForm: e.target.value })}
                    margin="normal"
                    InputProps={{
                      endAdornment: <InputAdornment position="end">cm</InputAdornment>
                    }}
                  />

                </Grid>
                <Grid item xs={12}>
                  <TextField
                    label="Dimensi Tinggi"
                    type="number"
                    // className={classes.textField}
                    value={this.state.heightDimensionForm}
                    fullWidth
                    onChange={(e) => this.setState({ heightDimensionForm: e.target.value })}
                    margin="normal"
                    InputProps={{
                      endAdornment: <InputAdornment position="end">cm</InputAdornment>
                    }}
                  />

                </Grid>
                <Grid item xs={12}>
                  <TextField
                    label="Dimensi Lebar"
                    type="number"
                    // className={classes.textField}
                    value={this.state.widthDimensionForm}
                    fullWidth
                    onChange={(e) => this.setState({ widthDimensionForm: e.target.value })}
                    margin="normal"
                    InputProps={{
                      endAdornment: <InputAdornment position="end">cm</InputAdornment>
                    }}
                  />

                </Grid>
              </Grid>
              <Grid item xs={6}>
                <Grid item xs={12}>
                  <TextField
                    label="Kapasitas Beban"
                    type="number"
                    // className={classes.textField}
                    value={this.state.loadCapacityForm}
                    fullWidth
                    onChange={(e) => this.setState({ loadCapacityForm: e.target.value })}
                    margin="normal"
                    InputProps={{
                      endAdornment: <InputAdornment position="end">gram</InputAdornment>
                    }}
                  />

                </Grid>
                <Grid item xs={12}>
                  <TextField
                    label="Kecepatan Maksimal"
                    type="number"
                    // className={classes.textField}
                    value={this.state.maxSpeedForm}
                    fullWidth
                    onChange={(e) => this.setState({ maxSpeedForm: e.target.value })}
                    margin="normal"
                  />

                </Grid>
                <Grid item xs={12}>
                  <TextField
                    label="Kecepatan Minimal"
                    type="number"
                    // className={classes.textField}
                    value={this.state.minSpeedForm}
                    fullWidth
                    onChange={(e) => this.setState({ minSpeedForm: e.target.value })}
                    margin="normal"
                  />

                </Grid>
                <Grid item xs={12}>
                  <TextField
                    label="Kecepatan Rata-Rata"
                    type="number"
                    // className={classes.textField}
                    value={this.state.averageSpeedForm}
                    fullWidth
                    onChange={(e) => this.setState({ averageSpeedForm: e.target.value })}
                    margin="normal"
                  />

                </Grid>
                <Grid item xs={12}>
                  <TextField
                    label="Deskripsi"
                    multiline
                    // className={classes.textField}
                    value={this.state.descriptionForm}
                    fullWidth
                    onChange={(e) => this.setState({ descriptionForm: e.target.value })}
                    margin="normal"
                  />

                </Grid>
              </Grid>
            </Grid>
          </div>
        </Dialog>
      </div>
    );
  }
}

export default withStyles(styles)(DialogForm);


// WEBPACK FOOTER //
// ./app/routes/MasterVehicleType/DialogForm.js